import { atom } from 'jotai';

const isCartOpenAtom = atom(false);

export default isCartOpenAtom;
